import { createSlice } from '@reduxjs/toolkit';

const slice = createSlice({
  name: 'mail',
  initialState: {},
  reducers: {},
});

export default slice.reducer;
